import { useState, useEffect } from 'react';
import api from '../services/api';
import Swal from 'sweetalert2';
import Select from 'react-select';

export default function ModalCobro({ items, total, onSuccess, onCancel, ordenId = null, esSeparada = false }) {
  const [clients, setClients] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);
  const [tipoDocumento, setTipoDocumento] = useState('01');
  const [cash, setCash] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    api.get('/clients').then(res => {
      const data = res.data.data ?? res.data;
      setClients(data);
      const varios = data.find(c => c.nombre.toUpperCase() === 'CLIENTES VARIOS');
      if (varios) {
        setSelectedClient({ value: varios.id, label: varios.nombre });
      }
    });
  }, []);

useEffect(() => {
  if (selectedClient) {
    const cliente = clients.find(c => c.id === selectedClient.value);
    if (cliente) {
      setTipoDocumento('01'); // 👈 Siempre Consumidor Final por defecto
    }
  }
}, [selectedClient, clients]);

  const clienteFull = selectedClient ? clients.find(c => c.id === selectedClient.value) : null;
  const puedeElegirTipoFactura = clienteFull?.tipo_cliente === 'Contribuyente';
  const clientOptions = clients.map(c => ({ value: c.id, label: c.nombre }));

  const submitSale = async () => {
    if (!selectedClient) return Swal.fire('Error', 'Seleccione un cliente', 'warning');
    if (Number(cash) < total) return Swal.fire('Error', 'Monto insuficiente', 'warning');
    if (tipoDocumento === '03' && clienteFull?.tipo_cliente !== 'Contribuyente') {
      return Swal.fire('Error', 'No se puede emitir Crédito Fiscal a un cliente No Contribuyente', 'error');
    }
    if (isSubmitting) return;
    setIsSubmitting(true);

    try {
      const cashAmount = parseFloat(cash) || 0;
      const clienteData = clients.find(c => c.id === Number(selectedClient.value));

      // Si es cuenta completa, cerrar la orden primero
      if (ordenId && !esSeparada) {
        await api.post(`/ordenes/${ordenId}/cerrar`, { tipo_pago: 'efectivo' });
      }

      const details = items.map(item => ({
        product_id: Number(item.product_id),
        presentation_id: item.presentation_id || null,
        cantidad: Number(item.cantidad) || 1,
        precio_unitario: Number(item.precio_unitario) || 0,
      }));

      const fechaMySQL = new Date().toISOString().slice(0, 19).replace('T', ' ');

      const payload = {
        client_id: Number(selectedClient.value),
        tipo_cliente: clienteData.tipo_cliente.toLowerCase().replace(' ', '_'),
        fecha_venta: fechaMySQL,
        details,
        subtotal: total,
        total_gravado: total,
        total_exento: 0,
        iva_total: 0,
        monto_final: total,
        condicion_operacion: 'CONTADO',
        estado: 'PENDIENTE',
        cash: cashAmount,
        change: cashAmount - total,
        tipo_documento: tipoDocumento,
      };

      const saleRes = await api.post('/sales', payload);
      const saleData = saleRes.data.data;

      onSuccess({
        ...saleData,
        cash: payload.cash,
        change: payload.change,
      });

      setCash('');
    } catch (error) {
      Swal.fire('Error', error.response?.data?.message || 'Error al facturar', 'error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div className="modal fade show d-block">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content card">
            <div className="card-header">
              <h3 className="card-title" style={{ margin: 0 }}>💰 Cobro</h3>
              <button className="btn btn-secondary btn-sm" onClick={onCancel}>✕</button>
            </div>

            <div className="card-body">
              <div className="form-group mb-3">
                <label className="form-label" style={{ fontWeight: 600 }}>Cliente</label>
                <Select
                  options={clientOptions}
                  value={selectedClient}
                  onChange={setSelectedClient}
                  placeholder="Seleccionar cliente..."
                  styles={{
                    control: (base) => ({
                      ...base,
                      borderColor: '#e2e8f0',
                      borderWidth: '2px',
                      borderRadius: '10px',
                      padding: '4px',
                      '&:hover': { borderColor: '#667eea' }
                    })
                  }}
                />
              </div>

              <div className="form-group mb-3">
                <label className="form-label" style={{ fontWeight: 600 }}>Tipo de Factura</label>
                {!puedeElegirTipoFactura ? (
                  <div style={{ padding: '12px', background: '#f0f9ff', borderRadius: '8px', border: '2px solid #0ea5e9' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <input type="radio" checked disabled />
                      <span style={{ fontWeight: 600 }}>📄 Consumidor Final</span>
                    </div>
                    <small style={{ color: '#0369a1', display: 'block', marginTop: '4px' }}>
                      Este cliente solo puede recibir factura de consumidor final
                    </small>
                  </div>
                ) : (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                    <div
                      onClick={() => setTipoDocumento('01')}
                      style={{ padding: '12px', background: tipoDocumento === '01' ? '#f0f9ff' : '#f7fafc', border: tipoDocumento === '01' ? '2px solid #0ea5e9' : '1px solid #e2e8f0', borderRadius: '8px', cursor: 'pointer' }}
                    >
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <input type="radio" checked={tipoDocumento === '01'} onChange={() => setTipoDocumento('01')} />
                        <span style={{ fontWeight: 600 }}>📄 Consumidor Final</span>
                      </div>
                    </div>
                    <div
                      onClick={() => setTipoDocumento('03')}
                      style={{ padding: '12px', background: tipoDocumento === '03' ? '#f0fdf4' : '#f7fafc', border: tipoDocumento === '03' ? '2px solid #10b981' : '1px solid #e2e8f0', borderRadius: '8px', cursor: 'pointer' }}
                    >
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <input type="radio" checked={tipoDocumento === '03'} onChange={() => setTipoDocumento('03')} />
                        <span style={{ fontWeight: 600 }}>💼 Crédito Fiscal</span>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              <div className="alert alert-success">
                <strong>Total a pagar:</strong> ${total.toFixed(2)}
              </div>

              <div className="form-group">
                <label className="form-label">Monto Recibido</label>
                <input
                  type="text"
                  inputMode="decimal"
                  className="form-control"
                  placeholder="0.00"
                  value={cash}
                  autoFocus
                  onChange={e => {
                    const value = e.target.value;
                    if (value === '' || /^\d*\.?\d*$/.test(value)) setCash(value);
                  }}
                  onKeyDown={e => {
                    if (e.key === 'Enter') {
                      e.preventDefault();
                      if (cash && Number(cash) >= total && !isSubmitting) submitSale();
                    }
                  }}
                  style={{ fontSize: '18px', fontWeight: '600' }}
                />
              </div>

              {cash !== '' && (
                <div className={`alert ${Number(cash) >= total ? 'alert-success' : 'alert-danger'} mt-3`}>
                  <strong>
                    {Number(cash) >= total
                      ? `✓ Vuelto: $${(Number(cash) - total).toFixed(2)}`
                      : '⚠ Monto insuficiente'}
                  </strong>
                </div>
              )}
            </div>

            <div className="card-body" style={{ borderTop: '2px solid #e2e8f0', display: 'flex', gap: '12px', paddingTop: '16px' }}>
              <button className="btn btn-secondary" onClick={onCancel} style={{ flex: 1 }}>
                Cancelar
              </button>
              <button
                className="btn btn-success"
                disabled={!cash || Number(cash) < total || isSubmitting}
                onClick={submitSale}
                style={{ flex: 1 }}
              >
                {isSubmitting ? (
                  <><span className="spinner-border spinner-border-sm me-2" />Procesando...</>
                ) : '✓ Facturar'}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
}